import { render, staticRenderFns } from "./upBlackList.vue?vue&type=template&id=5b83ce42&scoped=true&"
import script from "./upBlackList.vue?vue&type=script&lang=js&"
export * from "./upBlackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83ce42",
  null
  
)

export default component.exports